import { render, staticRenderFns } from "./UserSelectDialog.vue?vue&type=template&id=1ecb8837&scoped=true&"
import script from "./UserSelectDialog.vue?vue&type=script&lang=js&"
export * from "./UserSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectDialog.vue?vue&type=style&index=0&id=1ecb8837&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb8837",
  null
  
)

export default component.exports